import {
  Camera,
  rootSelection,
  useOpenInstance,
  useSetDisableFocusOnScene,
  useSetNextCamera,
} from '@k3/core'
import { useEffect } from 'react'
import { Vector3 } from 'three'
import { Keys } from '../../../../hooks/state/utlility/utils'
import { useMeasures } from '../../../../hooks/state/useMeasures'

const emptyCamera: Camera = {
  id: '',
  name: '',
  type: 'PerspectiveCamera',
  position: [0, 0, 0],
  lookAt: [0, 0, 0],
  rotation: [0, 0, 0],
  baseSettings: {
    fov: 0,
    aspect: 0,
    near: 0,
    far: 0,
  },
}

export function useSidewallCamera(
  sidewallId: string | undefined,
  position: Vector3,
  type: string | undefined,
  name: string
) {
  const openInstance = useOpenInstance()
  const { isQuer } = useMeasures()
  const setNextCamera = useSetNextCamera()
  const setDisableFocusOnScene = useSetDisableFocusOnScene()

  useEffect(() => {
    if (openInstance?.id === sidewallId) {
      const offset = 1
      const cameraPosition = position.toArray()
      switch (type) {
        case Keys.Seitenwände.Values.SeitenwandLinks.key:
          isQuer ? (cameraPosition[0] -= offset) : (cameraPosition[2] += offset)
          break
        case Keys.Seitenwände.Values.SeitenwandRechts.key:
          isQuer ? (cameraPosition[0] += offset) : (cameraPosition[2] += offset)
          break
        case Keys.Seitenwände.Values.SeitenwandMittig.key:
          isQuer ? (cameraPosition[2] += offset) : (cameraPosition[0] += offset)
          break
        case Keys.Seitenwände.Values.SeitenwandHinten.key:
          isQuer ? (cameraPosition[2] += offset) : (cameraPosition[0] -= offset)
      }

      const camera: Camera = {
        ...emptyCamera,
        id: name,
        name,
        position: cameraPosition,
        lookAt: position.toArray(),
        objectNames: [name],
      }
      setDisableFocusOnScene(true)
      setNextCamera(camera)
    } else if (openInstance?.id === rootSelection.id) {
      setDisableFocusOnScene(false)
    }
  }, [setNextCamera, sidewallId, openInstance?.id])
}
